var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { Button } from 'oned';
import { createForm } from 'rc-form';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { AmplitudeEventName } from '@common/enums/base';
import { getCurrentEnv, sendAmplitude_Default } from '@common/utils';
import NewAvailabilityIndex from './newAvailabilityIndex';
import { AvailAbilityStep, AvailabilityType, FlexibleType } from '@common/enums/availability';
import FlexibleIndex from './flexibleIndex';
import NewAvailabilityTimes from './newAvailabilityTimes';
import SummaryScreen from './summary';
import AvailabilityDialog from './availabilityDialog';
import Cookies from "js-cookie";
var NewAvailability = inject(AvailabilityBusiness)(observer(function (props) {
    var isCritical = props.isCritical, loading = props.loading, isShowAavilability = props.isShowAavilability, next = props.next, isNextDiabled = props.isNextDiabled, getAvailabilityData = props.getAvailabilityData, handleSelectedForReviewDisplay = props.handleSelectedForReviewDisplay, currentUser = props.currentUser, setTargetDisclaimer = props.setTargetDisclaimer, availabilityStep = props.availabilityStep, setAvailabilityParams = props.setAvailabilityParams, availabilityType = props.availabilityType, flexibleType = props.flexibleType, selectedAvailabilityTimes = props.selectedAvailabilityTimes, form = props.form;
    var handleNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            stepJump();
            return [2 /*return*/];
        });
    }); };
    var stepJump = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!forceNext()) {
                        return [2 /*return*/, false];
                    }
                    _a = availabilityStep;
                    switch (_a) {
                        case AvailAbilityStep.AvailabilityIndex: return [3 /*break*/, 1];
                        case AvailAbilityStep.FlexibleIndex: return [3 /*break*/, 2];
                        case AvailAbilityStep.FlexibleTime: return [3 /*break*/, 3];
                        case AvailAbilityStep.LimitedTime: return [3 /*break*/, 4];
                        case AvailAbilityStep.UnavailabilitySummary: return [3 /*break*/, 5];
                        case AvailAbilityStep.AvailabilitySummary: return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 8];
                case 1:
                    if (availabilityType === AvailabilityType.Flexible) {
                        setAvailabilityParams('availabilityStep', AvailAbilityStep.FlexibleIndex);
                    }
                    else {
                        setAvailabilityParams('availabilityStep', AvailAbilityStep.LimitedTime);
                    }
                    return [3 /*break*/, 8];
                case 2:
                    if (flexibleType === FlexibleType.NotAvailable) {
                        setAvailabilityParams('availabilityStep', AvailAbilityStep.FlexibleTime);
                    }
                    else {
                        next();
                    }
                    return [3 /*break*/, 8];
                case 3:
                    if (selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length > 0) {
                        setAvailabilityParams('availabilityStep', AvailAbilityStep.UnavailabilitySummary);
                    }
                    return [3 /*break*/, 8];
                case 4:
                    if (selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length > 0) {
                        setAvailabilityParams('availabilityStep', AvailAbilityStep.AvailabilitySummary);
                    }
                    return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, form.validateFields()];
                case 6:
                    _b.sent();
                    return [4 /*yield*/, handleSelectedForReviewDisplay()];
                case 7:
                    _b.sent();
                    sendAmplitude_Default(AmplitudeEventName.NewRSP_Step4to5, {
                        userId: currentUser.userId,
                        residentId: currentUser.residentId,
                        clientId: Cookies.get('clientId'),
                        env: getCurrentEnv(),
                    });
                    next();
                    setTargetDisclaimer(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var forceNext = function () {
        if (isCritical || !isShowAavilability) {
            handleSelectedForReviewDisplay();
            sendAmplitude_Default(AmplitudeEventName.NewRSP_Step4to5, {
                userId: currentUser.userId,
                residentId: currentUser.residentId,
                clientId: Cookies.get('clientId'),
                env: getCurrentEnv(),
            });
            next();
            setTargetDisclaimer(false);
            return true;
        }
        return false;
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'dsm-card' },
            React.createElement("div", { className: 'dsm-card-body' },
                isShowAavilability && !loading && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'py-2 px-20 availability' },
                        isCritical && React.createElement(React.Fragment, null,
                            React.createElement("h2", null,
                                React.createElement("b", { className: 'title' }, "Select your availability")),
                            React.createElement("div", { className: 'pt-2 ft-16' }, "This work order is critical priority. We will dispatch to an affiliate who will reach out directly to schedule.")),
                        availabilityStep === AvailAbilityStep.AvailabilityIndex && !isCritical && React.createElement(NewAvailabilityIndex, null),
                        availabilityStep === AvailAbilityStep.FlexibleIndex && !isCritical && React.createElement(FlexibleIndex, null),
                        (availabilityStep === AvailAbilityStep.FlexibleTime || availabilityStep === AvailAbilityStep.LimitedTime) &&
                            !isCritical &&
                            React.createElement(NewAvailabilityTimes, null),
                        (availabilityStep === AvailAbilityStep.UnavailabilitySummary || availabilityStep === AvailAbilityStep.AvailabilitySummary) &&
                            React.createElement(SummaryScreen, { form: form }))),
                !isShowAavilability && !loading && React.createElement("div", { className: 'w-100 d-flex justify-content-center py-5' }, "No availability permission."))),
        React.createElement(Button, { type: "primary", className: "w-100 my-3 dsm-btn-primary dsm-btn", disabled: isNextDiabled || loading, onClick: function () { return handleNext(); } }, "Next"),
        React.createElement(AvailabilityDialog, null));
}));
export default createForm()(NewAvailability);
